import { render, staticRenderFns } from "./EtsyRankModule.vue?vue&type=template&id=efdbefba"
import script from "./EtsyRankModule.vue?vue&type=script&lang=js"
export * from "./EtsyRankModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports